import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Session, StaffRole } from '@pocketbuy/outdoor-business-types';

type SessionStore = { session?: Session; setSession: (session: Session) => void; chooseRole: (role: StaffRole) => void; clearSession: () => void };

export const useSession = create<SessionStore>()(persist((set) => ({
  setSession: (session) => set({ session }),
  chooseRole: (activeRole) => set((state) => state.session ? { session: { ...state.session, activeRole } } : state),
  clearSession: () => set({ session: undefined }),
}), {
  name: 'pocketbuy-outdoor-session',
  merge: (persisted, current) => {
    const saved = (persisted as Partial<SessionStore>)?.session;
    const valid = saved?.accessToken && saved.expiresAt && new Date(saved.expiresAt).getTime() > Date.now();
    return { ...current, session: valid ? saved : undefined };
  },
}));
